import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import TentativeFamilyPlanForm from "./TentativeFamilyPlanForm";
import { createFamilyPlan } from "../../../store/slices/tentativeFamilyPlanSlice";
import { fetchPatient } from "../../../store/slices/patientsSlice";

const AddTentativeFamilyPlan = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state) => state.tentativeFamilyPlan);
    const { token } = useSelector((state) => state.auth);
    const { state } = useLocation();
    const { caseId, patientId } = state || {};

    const [formData, setFormData] = useState({
        patientId, // initialize
        caseId,    // initialize
        clientName: "",
        dateOfAdmission: "",
        historyTakingMeeting: "",
        firstCallWithFamily: "",
        callSchedule: "",
        monthlyFamilyMeeting: "",
        familyClientMeeting: "",
        outings: "",
        homeVisit: "",
        homeVisitDate: "",
        nightStay: "",
        nightStayDate: "",
        weekendStay: "",
        weekendStayDate: "",
    });

    useEffect(() => {
        if (patientId) {
            dispatch(fetchPatient(patientId))
                .unwrap()
                .then((patient) => {
                    if (patient) {
                        setFormData((prev) => ({
                            ...prev,
                            clientName: `${patient.first_name || ""} ${patient.last_name || ""}`.trim(),
                        }));
                    }
                })
                .catch((err) => console.error("Failed to prefill patient name for Family Plan:", err));
        }
    }, [dispatch, patientId]);

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const validateForm = () => {
        const newErrors = {};
        // if (!formData.clientName) newErrors.clientName = "Client name is required.";
        // if (!formData.dateOfAdmission)
        //   newErrors.dateOfAdmission = "Date of admission is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            Swal.fire({
                title: "Missing Fields",
                text: "Please fill all required fields before submitting.",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return;
        }

        try {
            const payload = {
                patient_id: formData.patientId || null,
                case_id: formData.caseId || null,
                client_name: formData.clientName,
                date_of_admission: formData.dateOfAdmission,
                history_taking_meeting: formData.historyTakingMeeting,
                first_call_with_family: formData.firstCallWithFamily,
                call_schedule: formData.callSchedule,
                monthly_family_meeting: formData.monthlyFamilyMeeting,
                family_client_meeting: formData.familyClientMeeting,
                outings: formData.outings,
                home_visit: formData.homeVisit,
                home_visit_date: formData.homeVisitDate,
                night_stay: formData.nightStay,
                night_stay_date: formData.nightStayDate,
                weekend_stay: formData.weekendStay,
                weekend_stay_date: formData.weekendStayDate,
            };
            console.log("Submitting payload:", payload);

            const resultAction = await dispatch(createFamilyPlan(payload));

            if (createFamilyPlan.fulfilled.match(resultAction)) {
                Swal.fire({
                    title: "Success!",
                    text: "Tentative Family Plan added successfully.",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false,
                });
                const res = resultAction.payload || resultAction;
            navigate(`/phase04/tentative-family-plan/edit/${res.id || res.data?.id || (res && res[0]?.id)}`, { state: { patientId: patientId || (res && res.patient_id), caseId: caseId || (res && res.case_id) } });
            } else {
                const errorMsg =
                    resultAction.payload ||
                    "Failed to create tentative family plan. Please try again.";
                Swal.fire({
                    title: "Error",
                    text: typeof errorMsg === "string" ? errorMsg : JSON.stringify(errorMsg),
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Unexpected error occurred.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        {Object.keys(errors).length > 0 && (
                            <div className="alert alert-danger">
                                {Object.values(errors).map((err, i) => (
                                    <div key={i}>{err}</div>
                                ))}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <TentativeFamilyPlanForm
                                formData={formData}
                                handleChange={handleChange}
                            />
                            <div className="col-12 d-flex justify-content-end mt-2">
                                <div className="mt-3 col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary px-4 sticky-form-submit">
                                        <i className="ri-save-3-line me-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddTentativeFamilyPlan;
